// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-catalog-__slug-indexstyleGrid-container-bldku{margin:0 auto;max-width:1536px;padding:0 12px;width:100%}.pages-catalog-__slug-indexstyleGrid-grid-bvnvx{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.pages-catalog-__slug-indexstyleGrid-col6-bkwng{grid-column:span 6}.pages-catalog-__slug-indexstyleGrid-col3-bjmzr{grid-column:span 3}.pages-catalog-__slug-indexstyleGrid-col4-bawvw{grid-column:span 4}.pages-catalog-__slug-indexstyleGrid-col9-cjchq{grid-column:span 9}.pages-catalog-__slug-indexstyleGrid-col12-beonu{grid-column:span 12}.pages-catalog-__slug-indexstyleGrid-alignItemsStart-bcovh{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "pages-catalog-__slug-indexstyleGrid-container-bldku",
	"grid": "pages-catalog-__slug-indexstyleGrid-grid-bvnvx",
	"col6": "pages-catalog-__slug-indexstyleGrid-col6-bkwng",
	"col3": "pages-catalog-__slug-indexstyleGrid-col3-bjmzr",
	"col4": "pages-catalog-__slug-indexstyleGrid-col4-bawvw",
	"col9": "pages-catalog-__slug-indexstyleGrid-col9-cjchq",
	"col12": "pages-catalog-__slug-indexstyleGrid-col12-beonu",
	"alignItemsStart": "pages-catalog-__slug-indexstyleGrid-alignItemsStart-bcovh"
};
module.exports = ___CSS_LOADER_EXPORT___;
